import { Button, MenuItem, Flex } from "@chakra-ui/react";
import { FaUserLock } from "react-icons/fa";

type Props = {
  userData?: {
    name: string;
    role: string | string[];
    sub: string;
    email: string;
    username: string;
  } | null;
  renderIn: "desktop" | "mobile";
};

export function AdminAccessButton({ userData, renderIn }: Props) {
  const handleClick = () => {
    window.location.href = `/interno`;
  };

  if (
    userData?.role !== "Colaborador" &&
    !userData?.role?.includes("Colaborador")
  )
    return null;

  if (renderIn === "mobile") {
    return (
      <MenuItem
        display={{ base: "flex", md: "none" }}
        onClick={handleClick}
        icon={<FaUserLock fontSize="1.1rem" />}
        py="2"
      >
        Área administrativa
      </MenuItem>
    );
  }

  if (renderIn === "desktop")
    return (
      <Flex
        display={{ base: "none", md: "block" }}
        h="full"
        alignItems="center"
        justifyContent="center"
        mr="6"
      >
        <Button
          variant="ghost"
          leftIcon={<FaUserLock fontSize="1.1rem" />}
          onClick={handleClick}
        >
          Área administrativa
        </Button>
      </Flex>
    );

  return <></>;
}
